function groupConsecutive(numbers) {
  return numbers.reduce((grouped, number) => {
    var lastGroup = grouped[grouped.length - 1] || [];
    var lastNumber = lastGroup[lastGroup.length - 1];
    if (number === lastNumber + 1) {
      lastGroup.push(number);
    } else {
      grouped.push([number]);
    }
    return grouped;
  }, []);
}

function consecutiveToRange(group) {
  if (group.length === 1) {
    return group[0].toString();
  } else {
    return group[0] + "-" + group[group.length - 1];
  }
}

export function asRange(numbers) {
  return groupConsecutive(numbers).map(consecutiveToRange).join(", ");
}

export function range(start, end) {
  var count = end - start + 1;
  return Array.apply(0, Array(count)).map(function (element, index) { return index + start; });
}
